import { JobType, ReqPriority, ReqTerm, ReqType } from "../requirement-my-sales/modal";

export enum SubStatusType {
    Submission = 1,
    Pipeline = 2,
    Eci = 3,
    Po = 4,
}

export type TPipeline = {
    submissionId: number;
    requirementId: number;
    jobTitle: string;
    vendorCompanyName: string;
    skillCategory: string;
    postedOn: string;
    salesManager: string
    recruiter: string;
    submital_Date: string;
    candidateId: number;
    candidateName: string;
    candidateEmail: string;
    subVendorCompanyName?: string;
    statusId: number;
    statusName: string;
    statusType: SubStatusType;
    status_IsPositive: boolean;
    status_ReadyToNext: boolean;
    comment: string;
}

export type TPipFilter = {
    fromDate: Date | string | null;
    toDate: Date | string | null;
    requirementId: number | null;
    reqType: ReqType | null;
    term: ReqTerm | null;
    priority: ReqPriority | null;
    jobType: JobType | null;
    industryId: number | null;
    skillCategoryId: number | null;
    interviewProcessId: number | null;
    noOfPositions: number | null;
}

export const EmptyPipFilter: TPipFilter = {
    fromDate: new Date(),
    toDate: new Date(),
    requirementId: null,
    reqType: null,
    term: null,
    priority: null,
    jobType: null,
    industryId: null,
    skillCategoryId: null,
    interviewProcessId: null,
    noOfPositions: null,
}
